import { makeStyles } from '@material-ui/styles';
import { grayColor } from 'assets/jss/material-dashboard-pro-react';

const useStyles = makeStyles({
  header: {
    margin: '0',
    fontWeight: '400',
    color: grayColor[3],
  },
});

const TermsHeader = ({ text }) => {
  const classes = useStyles();

  return <h4 className={classes.header}>{text}</h4>;
};

export default TermsHeader;
